import { CardData } from 'models';

export const CONSTS_SOLUTION_DATA: (CardData & { className?: string })[] = [
  {
    title: 'ced-criteria-block1-title',
    description: ['ced-criteria-block1-text'],
  },
  {
    title: 'ced-criteria-block2-title',
    description: ['ced-criteria-block2-text'],
  },
  {
    title: 'ced-criteria-block3-title',
    description: ['ced-criteria-block3-text1', 'ced-criteria-block3-text2'],
    className: 'cedolauto-is-smart-solution',
  },
];
